import { ProductPageLayout } from '../components/ProductPageLayout';

export function ShortAdsWorkflowPage() {
    return <ProductPageLayout productId="short-ads-workflow" />;
}
